<ng-container *ngIf="_data">
    <button 
        (click)="op.toggle($event)"
        [ngClass]="{'is-active': optionsSelectedCount}"
        class="container"
    >
        <span class="label">
            {{_data.filterLabel}}
        </span>
        <button *ngIf="!optionsSelectedCount" class="toggle-btn">
            <i class="pi pi-chevron-down icon"></i>
        </button>
        <div *ngIf="optionsSelectedCount" class="counter-selected-options">
            <span>
                {{optionsSelectedCount}}
            </span>
        </div>
    </button>

    <p-overlayPanel #op (onShow)="onShowDropdown()">
        <div class="container-filters">
            <span class="container-filters__title">
                {{_data.dropdownLabel}}
            </span>

            <div *ngIf="isVisibleSearchInput" class="container-filters__search">
                <span class="p-input-icon-left">
                    <i class="pi pi-search icon"></i>
                    <input 
                        type="text" 
                        pInputText
                        [placeholder]="'labels.search' | translate | titlecase"
                        [(ngModel)]="searchValue"
                        (ngModelChange)="searchInputValue$.next($event)"
                    />
                </span>
            </div>

            <div class="container-filters__list">
                <ng-container *ngFor="let controlFilterData of (searchValuePipe | filterArrByPropValue : _data.options : 'label'); let index = index">
                    <ng-container [ngSwitch]="_data.type">
                        <div *ngSwitchCase="FILTER_VEHICLE_TYPE.Status">
                            <div *ngTemplateOutlet="statusModeControl; context: { data: controlFilterData, filterLabel: _data.filterLabel, index: index }"></div>
                        </div>
                        <div *ngSwitchCase="FILTER_VEHICLE_TYPE.Group">
                            <div *ngTemplateOutlet="groupModeControl; context: { data: controlFilterData, filterLabel: _data.filterLabel, index: index }"></div>
                        </div>
                        <div *ngSwitchCase="FILTER_VEHICLE_TYPE.Blocking">
                            <div *ngTemplateOutlet="groupModeControl; context: { data: controlFilterData, filterLabel: _data.filterLabel, index: index }"></div>
                        </div>
                        <div *ngSwitchCase="FILTER_VEHICLE_TYPE.TachoStatus">
                            <div *ngTemplateOutlet="statusModeControl; context: { data: controlFilterData, filterLabel: _data.filterLabel, index: index }"></div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>

            <div class="container-filters__actions">
                <p-button (onClick)="submit(op)" class="submit" [label]="'labels.apply'|translate"></p-button>
                <button (click)="clearFilters(op)" class="cancel">
                    {{ 'labels.clear' | translate }}
                </button>
            </div>
        </div>
    </p-overlayPanel>

    <ng-template 
        #statusModeControl
        let-data="data"
        let-filterLabel="filterLabel"
        let-index="index"
    >
        <div class="control-wrapper">
            <p-radioButton 
                appRadioCheckboCustomColor
                [colorCheckbox]="data.checkboxColor || '#2d78ff'"
                [(ngModel)]="_selectedControlValue"
                [name]="filterLabel"
                [value]="data.value"
                styleClass="filters-vehicle-checkbox-selected-style"
                inputId="{{filterLabel}}-{{index}}"
                size="large"
            ></p-radioButton>
            <label for="{{filterLabel}}-{{index}}" class="control-wrapper__label">
                {{data.label}}
            </label>
        </div>
    </ng-template>

    <ng-template 
        #groupModeControl
        let-data="data"
        let-filterLabel="filterLabel"
        let-index="index"
    >
        <!-- <div class="control-wrapper">
            <p-checkbox 
                [(ngModel)]="checkboxValues[index].checkboxValue"
                [binary]="true"
                inputId="{{filterLabel}}-{{index}}"
            ></p-checkbox>
            <label for="{{filterLabel}}-{{index}}" class="control-wrapper__label">
                {{data.label}}
            </label>
        </div> -->
        <div class="control-wrapper">
            <p-radioButton 
                appRadioCheckboCustomColor
                [(ngModel)]="_selectedControlValue"
                [name]="filterLabel"
                [value]="data.value"
                styleClass="filters-vehicle-checkbox-selected-style"
                inputId="{{filterLabel}}-{{index}}"
                size="large"
            ></p-radioButton>
            <label for="{{filterLabel}}-{{index}}" class="control-wrapper__label">
                {{data.label}}
            </label>
        </div>
    </ng-template>
</ng-container>
